// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
'use strict';

var TypedGlamor = require("bs-typed-glamor/src/TypedGlamor.bs.js");

var root = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.display(TypedGlamor.inlineFlex),
      /* :: */[
        TypedGlamor.alignSelf(TypedGlamor.baseline),
        /* :: */[
          TypedGlamor.transforms(/* :: */[
                TypedGlamor.translateY(TypedGlamor.px(2)),
                /* [] */0
              ]),
          /* :: */[
            TypedGlamor.marginLeft(TypedGlamor.em(0.5)),
            /* :: */[
              TypedGlamor.opacity(0.5),
              /* :: */[
                TypedGlamor.select("& svg", /* :: */[
                      TypedGlamor.unsafe("fill", "currentColor"),
                      /* :: */[
                        TypedGlamor.height(TypedGlamor.em(1)),
                        /* :: */[
                          TypedGlamor.width(TypedGlamor.em(1)),
                          /* [] */0
                        ]
                      ]
                    ]),
                /* :: */[
                  TypedGlamor.hover(/* :: */[
                        TypedGlamor.opacity(1),
                        /* [] */0
                      ]),
                  /* [] */0
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var tooltip = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.backgroundColor(TypedGlamor.white),
      /* :: */[
        TypedGlamor.boxShadows(/* :: */[
              TypedGlamor.shadow(TypedGlamor.px(1), TypedGlamor.px(1), /* Some */[TypedGlamor.px(3)], /* Some */[TypedGlamor.px(1)], /* None */0, TypedGlamor.rgba(0, 0, 0, 0.1)),
              /* [] */0
            ]),
        /* :: */[
          TypedGlamor.padding2(TypedGlamor.em(0.5), TypedGlamor.em(1)),
          /* :: */[
            TypedGlamor.select("& div", /* :: */[
                  TypedGlamor.whiteSpace(TypedGlamor.nowrap),
                  /* :: */[
                    TypedGlamor.select("& a", /* :: */[
                          TypedGlamor.textDecoration(TypedGlamor.none),
                          /* :: */[
                            TypedGlamor.hover(/* :: */[
                                  TypedGlamor.textDecoration(TypedGlamor.underline),
                                  /* [] */0
                                ]),
                            /* [] */0
                          ]
                        ]),
                    /* :: */[
                      TypedGlamor.select("& svg", /* :: */[
                            TypedGlamor.unsafe("fill", "currentColor"),
                            /* :: */[
                              TypedGlamor.height(TypedGlamor.em(1)),
                              /* :: */[
                                TypedGlamor.width(TypedGlamor.em(1)),
                                /* :: */[
                                  TypedGlamor.marginRight(TypedGlamor.em(0.5)),
                                  /* :: */[
                                    TypedGlamor.verticalAlign(TypedGlamor.middle),
                                    /* :: */[
                                      TypedGlamor.transforms(/* :: */[
                                            TypedGlamor.translateY(TypedGlamor.px(-1)),
                                            /* [] */0
                                          ]),
                                      /* [] */0
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]),
                      /* [] */0
                    ]
                  ]
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

exports.root = root;
exports.tooltip = tooltip;
/* root Not a pure module */



// WEBPACK FOOTER //
// ./src/components/PlatformsStyles.js